export enum OrgLocationClassObjectSelectionMode {
  ORG_LOCATION_ONLY = 'ONLY_ORG_AND_LOCATION',
  CLASS_ONLY = 'CLASS_ONLY',
  OBJECT_ONLY = 'OBJECT_ONLY',
  ORG_LOCATION_AND_CLASS = 'ORG_LOCATION_AND_CLASS',
  // The user have to select organizations, locations and classes.
  // In the last step only those objects will be listed which are matching the organizations, locations and classes which were selected.
  ALL_COMBINED = 'COMBINED'
}
